export function useSplitSuggestionSections({
  suggestionSections,
  start,
  end
}) {
  const sections = suggestionSections === null || suggestionSections === void 0 ? void 0 : suggestionSections.slice(start, end);
  const remainingSections = suggestionSections === null || suggestionSections === void 0 ? void 0 : suggestionSections.slice(end);
  return {
    sections: sections || [],
    remainingSections: remainingSections || []
  };
}